"use strict";

/*global
 window, document, console, require, Foundation
 */

import 'lib/foundation-modules';

document.addEventListener('DOMContentLoaded', () => {

	$(document).foundation();

	$('.nav-icon').click(function(){
		$(this).toggleClass('open');
		$('.title-bar').toggleClass('selected');
	});


	$(document).click(function(e){
		if ($(e.target).closest("nav").length === 0) {
			// .closest can help you determine if the element
			// or one of its ancestors is #menuscontainer
			$('.top-bar').css('display','none');
			hideNav();
		}
	});
	function hideNav() {
		//$('nav').addClass('hidden').removeClass('visible');
		$('.nav-icon').removeClass('open');
		$('.top-bar').addClass('hidden');
	}

	$('.tabs-title').click(function(e) {
		hideTitle();
	});

	function hideTitle() {
		$('#minititle').hide();
	}


	$('.modalCaller').click(function(e){
		e.preventDefault();
		var video = $(this).data('video');
		var location = $(this).data('location');

		console.log('id: ',location);

//		$('#modalVideo').foundation('open');
		$('#modal-iframe').attr('src', 'https://www.youtube.com/embed/'+ video );
		// $('#modal-iframe').attr('src', 'https://www.youtube-nocookie.com/embed/'+ video +'?controls=1&rel=0');
		$('#modalVideo').data('location',location);
	});
	$('#modalVideo').on('closed.zf.reveal', function() {
		var anchor = $(this).data('location');

		console.log('passed id: ',anchor);

		$('#modal-iframe').attr('src', 'https://www.youtube.com/embed/');
		$('html,body').animate({
			scrollTop: $('.modalCaller'+anchor).offset().top
		}, 500);
	});


	$('.modalRadioCaller').click(function(e){
		e.preventDefault();
		var radio = $(this).data('radio');
		var radionumb = $(this).data('radiolocation');

		console.log('id: ',radionumb);

		// $('#modalRadio').foundation('open');
		$('#modal-radio-iframe').attr('src', 'https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/playlists/'+ radio +'&color=%23ff5500&auto_play=false&hide_related=false&show_comments=true&show_user=true&show_reposts=false&show_teaser=true&visual=true').css('width', '820px');
		$('#modalRadio').data('radiolocation',radionumb);
	});
	$('#modalRadio').on('closed.zf.reveal', function() {
		var radioankkuri = $(this).data('radiolocation');
		$('#modal-radio-iframe').attr('src', '#');

		console.log('passed id: ',radioankkuri);

		$('html,body').animate({
			scrollTop: $('.modalRadioCaller'+radioankkuri).offset().top
		}, 500);
	});


	// Frontpage tabs scrollTo command
	$('.featuretab').click(function(e) {
		e.preventDefault();
		$('html, body').animate({
			scrollTop: $(".tabs-content").offset().top-300
		}, 250);
	});

	$('.feature.tabs-title').click(function(e) {
		console.log('scroll');
		e.preventDefault();
		$('html, body').animate({
			scrollTop: $('.tabs-content-scrollto').offset().top
		}, 250);
	});


	$('.printimage').on('open.zf.reveal', function() {
		// $('.orbit').foundation('init');
		Foundation.reInit('orbit');
	});


	$('.caller').on('click', function (e) {
		e.preventDefault();
		var name = $(this).data('name');
		console.log(name);

		$('.slogansandlongertexts').hide();

		if(name == 'slogans') {
			$('.slogans-content').addClass('active');
		}
		if(name == 'longertexts') {
			$('.longertexts-content').addClass('active');
		}
	});

	$('#copy-sloganstexts-label, .slogans-close-button').on('click', function () {
		console.log('reset');

		$('.slogansandlongertexts').show();
		$('.longertexts-content').removeClass('active');
		$('.slogans-content').removeClass('active');

	});



	// Instantiate EasyZoom instances
	var $easyzoom = $('.easyzoom').easyZoom({
		width: 400,
	});

	// Get an instance API
	var api = $easyzoom.data('easyZoom');


	var lazyLoadInstance = new LazyLoad({
		elements_selector: ".lazy"
	});



	/*
	$('.zoomimage').hover(function() {
		//$('.orbit-slide').scrollLeft(-400);
		$('.borbitslide').addClass('transition');

	}, function() {
		$('.borbitslide').removeClass('transition');
	});
	*/




	$('.zoomer').on('click', function (e) {
		$(this).addClass('hidden');
		$('figure img').css('opacity', 0);
		$('.zoom').addClass('active');
	});

	$('.zoom').mousemove(function (e) {
		var zoomer = e.currentTarget;

		var offsetX;
		var offsetY;

		e.offsetX ? offsetX = e.offsetX : offsetX = e.touches[0].pageX;
		e.offsetY ? offsetY = e.offsetY : offsetX = e.touches[0].pageX;
		var x = offsetX / zoomer.offsetWidth * 100;
		var y = offsetY / zoomer.offsetHeight * 100;
		zoomer.style.backgroundPosition = x + '% ' + y + '%';
	});

	$('.zoom').mouseleave(function () {
		console.log('tyhjä');

		$('.zoomer').removeClass('hidden');
//		$('figure img').css('display', 'block');
		$('.zoom').removeClass('active');
	});









// SHOW/HIDE Nav
	var prevScrollpos = window.pageYOffset;
	window.onscroll = function() {
		var currentScrollPos = window.pageYOffset;

		// console.log(prevScrollpos);

		if (prevScrollpos > currentScrollPos) {
			// hide
			$('header').removeClass('hidden').addClass('visible');
		} else {
			// show
			if(prevScrollpos < 200 ) {
				// if scrolld less than 200px from top, show always.
				$('header').removeClass('hidden').addClass('visible');


			} else {
				console.log('a');

				if($('header').hasClass('hidden')) {
					$('header').addClass('hidden').removeClass('visible');
					$('.nav-icon').removeClass('open');
					$('.top-bar').css('display','none');
				} else {
					$('header').addClass('hidden').removeClass('visible');
				}
			}

		}

		prevScrollpos = currentScrollPos;
	};




	var counter=0;
	$(".animloader").each(function(){
		counter++;
		var self=$(this);
		self.addClass("count_"+counter);
		var tdCounter=0;
		self.find('td').each(function(){
			tdCounter++;
			$(this).addClass("count_"+counter+tdCounter);
		});
	});


});


